module.exports = __webpack_public_path__ + "static/media/help7.00bd9eb7.png";